import { useMutation } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

export const useDeleteDocument = () => {
    const chatService = new ChatService();
    return useMutation({
        mutationFn: ({ documentId, organizationId }: { documentId: string; organizationId: string }) =>
            chatService.deleteKnowledgeDocument(documentId, organizationId),
    });
};
